<template>
  <div>
    <div class="row justify-content-center">
      <div
        class="col-12 col-md-6 col-lg-6 mb-4"
        v-for="(item, idx) in paginatedBuletins"
        :key="idx">
        <div class="card p-3 h-100"  style="box-shadow: 0px 0px 7px 0px var(--shadow-color-1);">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted">
              <!-- {{ item.date }} -->
            </span>
            <button class="btn btn-sm btn-primary" @click="$emit('download', item.fileUrl)">
              <i class="bi bi-download"></i> {{ $t('buletinet.title') }}
            </button>
          </div>
          <div class="d-flex justify-content-center align-items-center" style="min-height: 60px;">
            <h5 class="card-title m-0 text-center">{{ item.title }}</h5>
          </div>
        </div>
      </div>
    </div>
    <!-- Pagination -->
    <div v-if="totalPages > 1" class="row mt-4">
      <div class="col-12 d-flex justify-content-center">
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="$emit('goToPage', currentPage - 1)">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li
              class="page-item"
              v-for="page in visiblePages"
              :key="page"
              :class="{ active: currentPage === page, disabled: page === '...'}">
              <button
                class="page-link"
                v-if="page !== '...'"
                @click="$emit('goToPage', page)">
                  {{ page }}
              </button>
              <span v-else class="page-link">...</span>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <button class="page-link" @click="$emit('goToPage', currentPage + 1)">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuletinsTemplate",
  props: {
    paginatedBuletins: Array,
    currentPage: Number,
    totalPages: Number,
    visiblePages: Array
  }
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border-radius: 16px;
}
.pagination .page-link {
  cursor: pointer;
}
.form-control {
  max-width: 300px;
}
.pagination {
  margin-top: 20px;
}
.page-link {
  color: #0b0a21;
  border: 1px solid #dde3eb;
  margin: 0 5px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.page-link:hover {
  background-color: #dde3eb;
}
.page-item.active .page-link {
  background-color: #2c3f5e;
  color: white;
  border-color: #2c3f5e;
}
.page-item.disabled .page-link {
  color: #6c757d;
  cursor: not-allowed;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}
tr th:first-child,
tr th:nth-child(3){
  width:150px;
}
tr th:nth-child(4){
  width:100px;
}

</style>
